const config = {
  apiPath: "https://models.aminer.cn/dinner",
  basename: "/",
};
export default config;
